import { createContext, useContext, type ReactNode } from "react";
import { useToast, type ToastType } from "../hooks/useToast";
import { ToastContainer } from "../components/ToastContainer";

interface ToastContextValue {
  showToast: (message: string, type?: ToastType) => void;
}

const ToastContext = createContext<ToastContextValue>({ showToast: () => {} });

export function ToastProvider({ children }: { children: ReactNode }) {
  const { toasts, showToast, dismissToast } = useToast(4000);
  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer toasts={toasts} onDismiss={dismissToast} />
    </ToastContext.Provider>
  );
}

export function useGlobalToast() {
  return useContext(ToastContext);
}
